import { useMemo } from "react";
import { DefectStatus } from "../..";

interface Props {
  status?: DefectStatus;
  className?: string;
  hint?: string;
}

export const StatusIcon = (props: Props) => {
  const className = useMemo(() => {
    switch (props.status) {
      case DefectStatus.OPEN:
        return "status-icon open ";
      case DefectStatus.IN_PROGRESS:
        return "status-icon in-prgress ";
      case DefectStatus.APPROVED:
        return "status-icon approved ";
      case DefectStatus.REJECTED:
        return "status-icon rejected ";
      default:
        return "status-icon unknown ";
    }
  }, [props.status]);

  return (
    <div
      className={className + (props.className ? props.className : "")}
      title={props.hint}
    ></div>
  );
};
